export default function HomeSectionHead({ label, title, desc }) {
  return (
    <div className="home-section-head">
      <div className="about-showcase-badge home-section-badge">
        <span>{label}</span>
      </div>
      <h2 className="home-section-title">{title}</h2>
      {desc ? <p className="home-section-desc">{desc}</p> : null}
    </div>
  );
}
